import React, { useState, FC } from "react";
import { Formik } from "formik";
import { RestoreShape } from "src/containers/Auth/interface/AuthForm.interface";
import { FormProps } from "src/shared/interfaces";
import { FormGenerator, Button } from "src/shared/components";

import { validationSchema, fields, getInitValues } from "./formHelpers";

export interface RestoreFormProps {
  email: string | null;
}

const RestoreForm: FC<FormProps<RestoreShape> & RestoreFormProps> = (props) => {
  const { email } = props;
  const [formValues] = useState(getInitValues(email));
  return (
    <Formik
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        props.submitHandler && props.submitHandler(values);
        setSubmitting(false);
      }}
      initialValues={formValues}>
      {(formikProps) => (
        <>
          <div className="auth-modal-hint">We’ll send you link to restore your password</div>
          <FormGenerator fields={fields} formikProps={formikProps}>
            <Button type="submit" disabled={props.loading || !validationSchema.isValidSync(formikProps.values)}>
              Send
            </Button>
          </FormGenerator>
        </>
      )}
    </Formik>
  );
};

export default RestoreForm;
